export const eventExist = name =>
  window && window.dataLayer?.some(track => track?.event === name);
